import useTypedFlags from "hooks/useTypedFlags";

import StackTasksList from "./List";
import StackTasksListLegacy from "./ListLegacy";

const StackTasks = () => {
  const { stackTasksListRedesign } = useTypedFlags();

  if (!stackTasksListRedesign) {
    return <StackTasksListLegacy />;
  }

  return <StackTasksList />;
};

export default StackTasks;
